<template>
  <div class="py-3">
    <h4>Booker Consistency</h4>
    <div
      class="row"
      v-if="['1', '9'].includes(currentUser.role_id) || isBdrUser()"
    >
      <div class="col-md-12 px-0">
        <div
          class="container-fluid w-100 mb-0 p-3 border bg-white rounded stats-wrapper"
        >
          <div class="d-flex flex-wrap">
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >Date</span
                >
              </div>
              <date-picker
                id="startDatePicker"
                class="form-control"
                v-model="filterMonth"
                :config="datePickerConfig"
                placeholder="Start Date"
              ></date-picker>
            </div>

            <!-- Select users bdr -->
            <div
              class="w-25 input-group input-group-sm p-1 treeselect-wrapper mr-3"
              v-if="!isBdrUser()"
            >
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >BDR</span
                >
              </div>
              <treeselect
                v-model="bdr_user_id"
                :options="bdr_users"
                :multiple="false"
                :clearable="false"
                :normalizer="normalizeOptions"
                class="form-control inline-table"
                @change="changeBDR"
              >
              </treeselect>
            </div>

            <button
              class="btn btn-success"
              @click="changeBDR()"
              style="width: 25%"
              :disabled="(loading || !bdr_user_id) && !isBdrUser()"
            >
              <i class="icon-calendar-check-o mr-2"></i>
              <small>
                {{ $t("lang.button.filter") }}
              </small>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12 ml-1 px-0" v-if="hasPermissions('superAdmin')" >
        <div class="mb-2 ml-3 cursor-pointer" v-if="!configNonWorkingAllBookers"  @click="configNonWorkingAllBookers = !configNonWorkingAllBookers">       
        <span class="text-primary">
          {{ $t('lang.label.day_non_working_all') }}
          <i class="icon-caret-down1 ml-2 mt-2"></i>
        </span>
      </div>

      <div v-else class="mb-2 ml-3 cursor-pointer" @click="configNonWorkingAllBookers = !configNonWorkingAllBookers">
        <span class="text-primary">
          {{ $t('lang.label.day_non_working_all') }}
          <i class="icon-caret-down1 ml-2 mt-2"></i>
        </span>
      </div>
        <div
        v-if="configNonWorkingAllBookers"
          class="container-fluid w-100 mb-5 p-1 border bg-white rounded stats-wrapper"
        >
      <div class="d-flex flex-wrap">
        <div class="w-25 input-group input-group-sm p-1">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-sm"
              >{{ $t('lang.label.non_working_days') }}</span
            >
        </div>
        <date-picker
          id="startDatePicker"
          class="form-control ml-2"
          v-model="dayNonWorking"
          :config="datePickerConfigComplete"
          :disabled="savingNonWorkingDays"
          placeholder="Start Date"
        />
      </div>
      <button
          class="btn btn-success ml-2"
          @click="applyNonWorkingDaysToAllBookers()"
          style="width: 15%"
          :disabled="savingNonWorkingDays || !dayNonWorking "
        >
          <small v-if="!savingNonWorkingDays" class="text-dark">
            {{ $t('lang.label.apply_all_bookers') }}
          </small>
          <div v-else class="spinner-border text-light" role="status" style="width: 1.5rem; height: 1.5rem;">
            <span class="sr-only">Loading...</span>
          </div>
        </button>
        <div v-if="lastNonDayLoaded" class="pl-2 pt-3">
          <small>
            {{  $t('lang.label.last_date_registered') }}: {{ lastNonDayLoaded}}
          </small>
          <i v-if="savingOk" class="fa fa-check  mr-2 ml-3 mt-2 text-success"></i>
        </div>
      </div>
    </div>
  </div>
  <!-- <div v-else class="mt-2 ml-3">
    <span class="text-primary"  @click="configNonWorkingAllBookers = !configNonWorkingAllBookers">
      Config Non working days to All Bookers 
      <i class="icon-caret-down1 ml-2 mt-2"></i>
    </span>
  </div> -->
    </div>

    <LoadingSpinner v-if="loading" />

    <div class="row" v-else>
      <div class="col-sm-12 mt-5">
        <div class="table-responsive">
          <div v-for="(parent, key) in parents" :key="parent + key">
            <div class="pb-4 max-content table-sticky-1col">
              <h5 class="text-bold ml-3 mt-2">{{ parent.parent_name }}</h5>
              <div class="table-sticky-1col">
                <StatsTable
                  :statsClient="statsClient[parent.parent_name]"
                  :statsType="getStatsTypeByParent(parent.parent_name)"
                  :statsDate="statsDate"
                  :statsDateTotal="statsDate.length"
                  :currentDateHour="currentDateHour"
                  :setObjetive="true"
                  :filterMonth="getFilterMonth()"
                  :daysNonWorking="daysNonWorking"
                  :showTotal="
                    parent.parent_name == 'Meeting Rate' ? false : true
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { opportunitiesService, usersService, bookersService } from "@/_services";
import StatsTable from "@/components/Usages/StatsTable.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    type: String,
    targetId: {
      type: String,
      default: "0",
    },
  },
  components: {
    StatsTable,
    LoadingSpinner,
    Treeselect,
  },
  data() {
    return {
      lastNonDayLoaded: null,
      savingOk: false,
      savingNonWorkingDays: false,
      dayNonWorking: null,
      configNonWorkingAllBookers: false,
      availableDays: [],
      daysNonWorking: [],
      currentDateHour: null,
      weeklyAvailability: [],
      callConversations: [],
      loading: false,
      statsClient: {},
      statsDate: [],
      parents: [],
      statsType: [
        // {
        //   id: "gmail_gmail",
        //   label: "gmail > gmail",
        //   format: "percentage",
        //   showQty: false,
        //   showTotal: false,
        //   parent: "sent",
        // },
      ],
      bdr_user_id: null,
      bdr_users: null,
      datePickerConfig: {
        format: "YYYY-MMM",
        // useCurrent: false,
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      datePickerConfigComplete: {
        format: "YYYY-MM-DD",
      },
      filterMonth: moment().format("YYYY-MMM"),
      // range: {
      //   startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      //   endDate: moment().format("YYYY-MM-DD"),
      // },
    };
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },
  created() {
    this.getUserBdr();
  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    applyNonWorkingDaysToAllBookers(){
      if(this.dayNonWorking == null) return false
     
      this.savingNonWorkingDays = true
      
      bookersService.applyNonWorkingAllBookers(this.dayNonWorking)
      .then(response => {
        this.savingNonWorkingDays = false
        this.savingOk = true
        this.lastNonDayLoaded = this.dayNonWorking
        this.dayNonWorking = null
      })
      .catch(error => {
        console.log("applyNonWorkingAllBookers error", error)
      })

    },
    getFilterMonth() {
      return moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");
    },
    isBdrUser() {
      return (
        this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2
      );
    },
    mergeObjects(statsX, statsX2) {
      statsX2.forEach((item2) => {
        let item = statsX.find((item) => item.fdate == item2.fdate);
        if (item) {
          Object.assign(item, item2);
        } else {
          statsX.push(item2);
        }
      });
      return statsX;
    },
    getWeekdaysOfMonth(year, month) {
      const availableDays = [];
      const date = moment(`${year}-${String(month).padStart(2, "0")}-01`);
      const daysInMonth = date.daysInMonth();

      for (let i = 1; i <= daysInMonth; i++) {
        const current = moment(`${year}-${month}-${i}`, "YYYY-MM-DD");
        const dayOfWeek = current.isoWeekday(); // 1 = lunes, 7 = domingo

        if (dayOfWeek >= 1 && dayOfWeek <= 5) {
          availableDays.push(current.format("YYYY-MM-DD"));
        }
      }

      this.availableDays = availableDays;
    },
    generateFilledDataByAvailability(doneTasks) {
      const filterD = moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");
      const date = moment(
        `${filterD.substring(0, 4)}-${String(filterD.substring(5, 7)).padStart(2, "0")}-01`
      );
      const daysInMonth = date.daysInMonth();

      // Index por día|hora de lo ya existente
      const byDayHour = new Map();
      (doneTasks || []).forEach((item) => {
        const key = `${String(item.fdate)}|${String(item._hour).padStart(2, "0")}`;
        byDayHour.set(key, item);
      });

      const result = [];

      for (let i = 1; i <= daysInMonth; i++) {
        const day = moment(
          `${filterD.substring(0, 4)}-${filterD.substring(5, 7)}-${String(i).padStart(2, "0")}`
        );

        const fullDate = day.format("YYYY-MM-DD");
        const dayOfWeek = day.isoWeekday(); // 1..7 (1 = lunes)
        const isFuture = day.isAfter(moment());

        // Excluir fines de semana, futuros y días no laborables
        if (dayOfWeek < 1 || dayOfWeek > 5 || isFuture) continue;
        if ((this.daysNonWorking || []).includes(fullDate)) continue;

        const weekdayIndex = dayOfWeek - 1; // 0..4
        const hoursAvailable = this.weeklyAvailability[weekdayIndex] || [];

        hoursAvailable.forEach((h) => {
          const hourStr = String(h).padStart(2, "0");
          const key = `${String(i)}|${hourStr}`;

          if (byDayHour.has(key)) {
            result.push(byDayHour.get(key));
          } else {
            result.push({
              fdate: String(i),
              name: `${hourStr} > ${String(h + 1).padStart(2, "0")}`,
              _hour: hourStr,
              total_tasks: "0",
              total_meetings: "0",
              total_opps: "0",
              total_verified_tasks: "0",
              total_conversation_calls: "0",
            });
          }
        });
      }

      // Ordenar por día y hora
      result.sort((a, b) => {
        const aDay = Number(a.fdate);
        const bDay = Number(b.fdate);
        if (aDay !== bDay) return aDay - bDay;
        return Number(a._hour) - Number(b._hour);
      });

      return result;
    },
    changeBDR() {
      const filterD = moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");

      this.getWeekdaysOfMonth(filterD.substring(0, 4), filterD.substring(5, 7));

      this.loading = true;
      this.statsClient = {};
      this.statsDate = [];
      this.parents = [];
      this.statsType = [];

      const userBdr = this.isBdrUser() ? this.currentUser.id : this.bdr_user_id;

      opportunitiesService
        .getBookersHistory({
          bdr_user_id: userBdr,
          month: this.filterMonth,
          type: this.type,
          target_id: this.targetId,
        })
        .then((res) => {
          if (res) {
            // 1) Construyo disponibilidad semanal antes de expandir horas
            this.weeklyAvailability = (res["working_hours_availability"] || []).reduce(
              (acc, daySchedule) => {
                const dayHours = (daySchedule.hours || []).reduce((hours, range) => {
                  if (range) {
                    for (let i = range.from; i <= range.to - 1; i++) {
                      hours.push(i);
                    }
                  }
                  return hours;
                }, []);

                acc[daySchedule.id] = dayHours;
                return acc;
              },
              {}
            );

            this.currentDateHour = res["date_hour"];
            this.daysNonWorking = res["days_non_working"];

            // 2) Expandir doneTasks con TODAS las horas declaradas
            res["doneTasks"] = this.generateFilledDataByAvailability(res["doneTasks"] || []);

            this.callConversations = res["doneTasks"].filter(item => item.total_conversation_calls > 0).map(item => {
              return {
                fdate: item.fdate,
                name: item.name,
                total_conversation_calls: item.total_conversation_calls
              }
            });

            if (res["doneTasks"] !== null) {
              let statsX = this.formatData(
                res["newTasks"],
                "total_tasks",
                "New Tasks",
                "qty"
              );

              let statsX1;
              let statsX2;
              let statsX3;
              let statsX4;

              if (this.type == "consistency") {

                res["doneTasks"] = res["doneTasks"].map(item => {
                  const verifiedTasks = Number(item.total_verified_tasks) || 0;
                  const conversationCalls = Number(item.total_conversation_calls) || 0;
                  
                  let consistencyStatus = (verifiedTasks >= 20 || conversationCalls >= 4) ? 'yes' : 'no'
                  item.total_verified_tasks = {
                    label: verifiedTasks + ' / ' + conversationCalls,
                    status: consistencyStatus,
                    day: item.fdate,
                    name: item.name,
                    total_verified_tasks: verifiedTasks,
                    total_conversation_calls: conversationCalls,
                  } 
                  return item
                })  

               

                res["doneTasks"] = res["doneTasks"].map(item => {
                 
                  const total = res["doneTasks"].reduce((acc, value) => {
                    return acc + (value.total_verified_tasks.status === 'yes' && value.fdate == item.fdate ? 1 : 0);
                  }, 0);

                  return {
                    ...item,
                    total_verified_tasks: {
                      ...item.total_verified_tasks,
                      objective_success_total: total
                    }
                  }
                })



                statsX4 = this.formatData(
                  res["doneTasks"],
                  "total_verified_tasks",
                  //"total_conversation_calls",
                  "Consistency",
                  "qty"
                );                

              } else {
                statsX = this.formatData(
                  res["newTasks"],
                  "total_tasks",
                  "New Tasks",
                  "qty"
                );

                statsX1 = this.formatData(
                  res["newTasks"],
                  "residual_tasks",
                  "Residual Tasks",
                  "qty"
                );

                statsX2 = this.formatData(
                  res["doneTasks"],
                  "total_tasks",
                  "Done Tasks",
                  "qty"
                );
                statsX3 = this.formatData(
                  res["doneTasks"],
                  "total_opps",
                  "Managed opportunities",
                  "qty"
                );

                statsX4 = this.formatData(
                  res["doneTasks"],
                  "total_verified_tasks",
                  "Verified tasks",
                  "qty"
                );
              }

              if (this.type == "consistency") {
                statsX = this.mergeObjects(statsX, statsX4);
              } else {
                statsX = this.mergeObjects(statsX, statsX1);
                statsX = this.mergeObjects(statsX, statsX2);
                statsX = this.mergeObjects(statsX, statsX3);
                statsX = this.mergeObjects(statsX, statsX4);

                statsX2 = this.formatData(
                  res["doneTasks"],
                  "total_meetings",
                  "Meetings booked",
                  "qty"
                );

                statsX = this.mergeObjects(statsX, statsX2);

                statsX2 = this.formatData(
                  res["doneTasks"],
                  ["total_meetings", "total_verified_tasks"],
                  "Meeting Rate",
                  "rate"
                );

                statsX = this.mergeObjects(statsX, statsX2);
              }

              if (this.type == "consistency" && res.firstDateWorking ) {
                const firstDateWorking = moment(res.firstDateWorking, "YYYY-MM-DD HH:mm:ss");
                const yearFirstDateWorking = firstDateWorking.year();   
                const monthFirstDateWorking = firstDateWorking.month() + 1;                 
                const dayFirstDateWorking = firstDateWorking.date()              

                const dateSelected = moment(this.filterMonth, "YYYY-MMM");
                
                // Obtener año y mes como números
                const year = dateSelected.year();           
                const month = dateSelected.month() + 1;     

                if(yearFirstDateWorking == year && monthFirstDateWorking == month){
                  statsX = statsX.filter(item => Number(item.fdate) >= dayFirstDateWorking);             
                }
                
              }

              statsX.forEach((item) => {
                const client_id = item.client_id ? item.client_id : 0;
                const client_name = item.client_name ? item.client_name : "";
                const fdate = item.fdate;

                if (!this.statsDate.find((field) => field.date == fdate)) {
                  this.statsDate.push({ date: fdate });
                }

                this.statsType.forEach((statType) => {
                  let type = statType.id + "_" + statType.format;
                  let parent = statType.parent;

                  if (
                    !this.parents.find((field) => field.parent_name == parent)
                  ) {
                    this.parents.push({ parent_name: parent });
                  }

                  if (this.statsClient[parent] == undefined) {
                    this.statsClient[parent] = {};
                  }
                  if (this.statsClient[parent][client_id] == undefined) {
                    this.statsClient[parent][client_id] = {};
                    this.statsClient[parent][client_id]["name"] = client_name;
                  }
                  if (this.statsClient[parent][client_id][fdate] == undefined) {
                    this.statsClient[parent][client_id][fdate] = item;
                  }

                  if (item[type] !== undefined && item[type] !== null) {
                    if (
                      this.statsClient[parent][client_id][type] === undefined
                    ) {
                      this.statsClient[parent][client_id][type] = 0;
                      this.statsClient[parent][client_id][type + "_total"] = 0;
                      this.statsClient[parent][client_id][
                        type + "_objective_total"
                      ] = 0;
                      this.statsClient[parent][client_id][
                        type + "_objective_success_total"
                      ] = 0;
                    }
                    this.statsClient[parent][client_id][type] += parseFloat(
                      item[type]
                    );
                    this.statsClient[parent][client_id][type + "_total"]++;

                    this.statsClient[parent][client_id][
                      type + "_objective_total"
                    ]++; // = this.statsClient[parent][client_id][type + "_objective_total"] + 1;
                    this.statsClient[parent][client_id][
                      type + "_objective_success_total"
                    ] = 5;
                  }
                });
              });

              this.statsDate.sort((a, b) => a.date - b.date);

              this.statsType.forEach((statType) => {
                let type = statType.id + "_" + statType.format;
                let parent = statType.parent;

                if (["avg", "percentage", "rate"].includes(statType.format)) {
                  // arreglar promedio

                  this.statsClient[parent][0][type] =
                    this.statsClient[parent][0][type] /
                    this.statsClient[parent][0][type + "_total"];
                }
              });
            }

            this.loading = false;
          }
        });
    },
    getUserBdr() {
      usersService
        .getBdrs()
        .then((res) => {
          this.bdr_users = res.result;
        })
        .catch((err) => consolelog(err));
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    formatData(x, field_value, parent, format_type) {
      let statsX = [];
      let total = 0;
      let total1 = 0;
      let total2 = 0;
      x.forEach((item) => {
        const fdate = item.fdate;

        // Obtenemos el año y el mes
        const date = moment(this.filterMonth, "YYYY-MMM");
        const year = date.format("YYYY");
        const month = date.format("MM");

        const day = this.getWeekdayValue(year, month, fdate);
        const availableHours = this.weeklyAvailability[day] || [];
        const callConversations = this.callConversations || [];

        if (!statsX.find((field) => field.fdate == fdate)) {
          statsX.push({ fdate: fdate, availableHours: availableHours });
          statsX.push({ fdate: fdate, callConversations: callConversations });
        }
        let statWeek = statsX.find((field) => field.fdate == fdate);
        let label = item.name;
        let key = label + "_" + parent;

        let value = 0;
        if (Array.isArray(field_value)) {
          if (item[field_value[1]] > 0) {
            let val0 = parseInt(item[field_value[0]]);
            let val1 = parseInt(item[field_value[1]]);
            total1 += val0;
            total2 += val1;
            total = total1 / total2;
            value = val0 / val1;
            if (["percentage", "rate"].includes(format_type)) {
              value = value * 100;
            }
          }
        } else {
          value = item[field_value];
        }

        statWeek[key + "_" + format_type] = value;
        if (Array.isArray(field_value)) {
          statWeek["Total_" + parent + "_" + format_type] = total * 100;

          if (!this.statsType.find((field) => field.id == "Total_" + parent)) {
            this.statsType.push({
              id: "Total_" + parent,
              label: "Total",
              format: format_type,
              showQty: false,
              showTotal: true,
              parent: parent,
              className: "font-weight-bold",
            });
          }
        }

        if (!this.statsType.find((field) => field.id == key)) {
          this.statsType.push({
            id: key,
            label: label,
            format: format_type,
            showQty: false,
            showTotal: true,
            applyBgColor: item.applyBgColor,
            parent: parent,
          });
        }
      });
      return statsX;
    },

    getWeekdayValue(year, month, day) {
      const date = moment(`${year}-${month}-${day}`, "YYYY-M-D");

      const weekday = date.isoWeekday();

      if (weekday >= 1 && weekday <= 5) {
        return weekday - 1;
      } else {
        return null;
      }
    },

    getStatsTypeByParent(parent) {
      if (this.type == "consistency") {
        let x = this.statsType.filter((e) => e.parent === parent);

        const entries = Object.entries(x);

        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          let a = valueA.label == "Total" ? 9999 : parseInt(valueA.label);
          let b = valueB.label == "Total" ? 9999 : parseInt(valueB.label);
          return a - b;
        });

        return entries.map(([, value]) => value);
      }

      if (this.type == "timing") {
        let x = this.statsType.filter((e) => e.parent === parent);

        const entries = Object.entries(x);

        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          let a = valueA.label == "Total" ? 9999 : parseInt(valueA.label);
          let b = valueB.label == "Total" ? 9999 : parseInt(valueB.label);
          return a - b;
        });

        return entries.map(([, value]) => value);
      } else {
        let x = this.statsType.filter((e) => e.parent === parent);
        const customOrder = [
          "Reschedule",
          "Urgent",
          "Positive",
          "Calendar inspection",
          "Introduction",
          "Wrong contact",
          "Negative",
          "Cold",
          "Other Answer",
          "Total",
        ];

        const entries = Object.entries(x);

        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          const indexA = customOrder.indexOf(valueA.label);
          const indexB = customOrder.indexOf(valueB.label);
          return (
            (indexA === -1 ? Infinity : indexA) -
            (indexB === -1 ? Infinity : indexB)
          );
        });

        return entries.map(([, value]) => value);
      }
    },
    getRate(a, b) {
      if (b == 0) {
        return 0;
      } else {
        return (parseFloat(a) / parseFloat(b)) * 100;
      }
    },
  },
};
</script>
